import Message from "../../message";
import {useMainStore} from "@/store";

export default class BracketAssigned extends Message
{
    handle()
    {
        useMainStore().SET_GUILD_TIER(this.message.tier);
        useMainStore().SET_GUILD_BRACKET(this.message.bracket);
    }
}
